import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'core.errorNotification.title',
    defaultMessage: 'Error',
  },
  copy: {
    id: 'core.errorNotification.copy',
    defaultMessage: 'Copy to clipboard',
  },
  copied: {
    id: 'core.errorNotification.copied',
    defaultMessage: 'Copied!',
  },
  submit: {
    id: 'core.form.ok',
    defaultMessage: 'Ok',
  },
  details: {
    id: 'core.errorNotification.details',
    defaultMessage: 'Details',
  },
  type: {
    id: 'core.errorNotification.details.type',
    defaultMessage: 'Type: {type}',
  },
  code: {
    id: 'core.errorNotification.details.code',
    defaultMessage: 'Code: {code}',
  },
  message: {
    id: 'core.errorNotification.details.message',
    defaultMessage: 'Message: {message}',
  },
  stack: {
    id: 'core.errorNotification.details.stack',
    defaultMessage: 'Stack trace',
  },
} as const);

export const errorMessages = defineMessages({
  systemError: {
    id: 'core.errorNotification.messages.systemError',
    defaultMessage: 'System error',
  },
  authFailed: {
    id: 'core.errorNotification.messages.authFailed',
    defaultMessage: 'Authentication failed',
  },
  notAuthenticated: {
    id: 'core.errorNotification.messages.notAuthenticated',
    defaultMessage: 'You are not authenticated',
  },
  wrongUsernameOrPassword: {
    id: 'core.errorNotification.messages.wrongUsernameOrPassword',
    defaultMessage: 'Wrong username or password',
  },
  accountBlocked: {
    id: 'core.errorNotification.messages.accountBlocked',
    defaultMessage: 'Account is blocked',
  },
  appNonAvailable: {
    id: 'core.errorNotification.messages.appNonAvailable',
    defaultMessage: 'Application is not available',
  },
  needChangePass: {
    id: 'core.errorNotification.messages.needChangePass',
    defaultMessage: 'You must change your password',
  },
  actionNotPermitted: {
    id: 'core.errorNotification.messages.actionNotPermitted',
    defaultMessage: 'You have no permissions to execute the action',
  },
  categoryNotPermitted: {
    id: 'core.errorNotification.messages.categoryNotPermitted',
    defaultMessage:
      'You have no permissions to the juridical person in this category',
  },
  internalApiError: {
    id: 'core.errorNotification.messages.internalApiError',
    defaultMessage: 'Internal API error',
  },
  internalProviderError: {
    id: 'core.errorNotification.messages.internalProviderError',
    defaultMessage: 'Internal provider error',
  },
  notImplemented: {
    id: 'core.errorNotification.messages.notImplemented',
    defaultMessage: 'Not implemented',
  },
  notFound: {
    id: 'core.errorNotification.messages.notFound',
    defaultMessage: 'Not found',
  },
  invalidSchema: {
    id: 'core.errorNotification.messages.invalidSchema',
    defaultMessage: 'Invalid schema',
  },
  invalidCategoryType: {
    id: 'core.errorNotification.messages.invalidCategoryType',
    defaultMessage: 'Invalid category type',
  },
  invalidDeletionOperation: {
    id: 'core.errorNotification.messages.invalidDeletionOperation',
    defaultMessage: 'Invalid deletion operation',
  },
  invalidCreationOperation: {
    id: 'core.errorNotification.messages.invalidCreationOperation',
    defaultMessage: 'Invalid creation operation',
  },
  insufficientPermissions: {
    id: 'core.errorNotification.messages.insufficientPermissions',
    defaultMessage: 'Insufficient permissions',
  },
  invalidSessionToken: {
    id: 'core.errorNotification.messages.invalidSessionToken',
    defaultMessage: 'Invalid session token',
  },
  sessionVerificationTimeout: {
    id: 'core.errorNotification.messages.sessionVerificationTimeout',
    defaultMessage: 'Verification timeout exceeded',
  },
  blocked: {
    id: 'core.errorNotification.messages.blocked',
    defaultMessage: 'This account is temporary blocked',
  },
  noSuchCategory: {
    id: 'core.errorNotification.messages.noSuchCategory',
    defaultMessage: 'Provided Category does not exist',
  },
  noSuchSubsystem: {
    id: 'core.errorNotification.messages.noSuchSubsystem',
    defaultMessage: 'Provided Subsystem does not exist',
  },
  noSuchCatalog: {
    id: 'core.errorNotification.messages.noSuchCatalog',
    defaultMessage: 'Provided Catalog does not exist',
  },
  noSuchRole: {
    id: 'core.errorNotification.messages.noSuchRole',
    defaultMessage: 'Provided Role does not exist',
  },
  noSuchPermission: {
    id: 'core.errorNotification.messages.noSuchPermission',
    defaultMessage: 'Provided Permission does not exist',
  },
  noSuchAction: {
    id: 'core.errorNotification.messages.noSuchAction',
    defaultMessage: 'Provided Action does not exist',
  },
  missingSubsystem: {
    id: 'core.errorNotification.messages.missingSubsystem',
    defaultMessage: 'Subsystem is mandatory',
  },
  missingCatalog: {
    id: 'core.errorNotification.messages.missingCatalog',
    defaultMessage: 'Catalog is mandatory',
  },
  unresolvedSubsystem: {
    id: 'core.errorNotification.messages.unresolvedSubsystem',
    defaultMessage: 'Category is not divided by Subsystem',
  },
  unresolvedCatalog: {
    id: 'core.errorNotification.messages.unresolvedCatalog',
    defaultMessage: 'Category is not divided by Catalog',
  },
  forbiddenPermission: {
    id: 'core.errorNotification.messages.forbiddenPermission',
    defaultMessage: 'Provided combination of access flags is forbidden',
  },
  notGlobalAdmin: {
    id: 'core.errorNotification.messages.notGlobalAdmin',
    defaultMessage: 'This can only be done by a global administrator',
  },
  invalidCatalog: {
    id: 'core.errorNotification.messages.invalidCatalog',
    defaultMessage: 'Invalid Catalog',
  },
  invalidAction: {
    id: 'core.errorNotification.messages.invalidAction',
    defaultMessage: 'Invalid Action',
  },
  foreignSubsystem: {
    id: 'core.errorNotification.messages.foreignSubsystem',
    defaultMessage: 'Foreign Subsystem',
  },
  foreignRole: {
    id: 'core.errorNotification.messages.foreignRole',
    defaultMessage: 'Foreign Subsystem of a Role',
  },
  logoffTimeout: {
    id: 'core.errorNotification.messages.logoffTimeout',
    defaultMessage: 'Time limit exceeded',
  },
  samePasswords: {
    id: 'core.errorNotification.messages.samePasswords',
    defaultMessage: 'The new password must be different from the existing one',
  },
  weakPassword: {
    id: 'core.errorNotification.messages.weakPassword',
    defaultMessage: 'The password is too weak',
  },
  smartCardAuthRequired: {
    id: 'core.errorNotification.messages.smartCardAuthRequired',
    defaultMessage: 'Required authentication with smart card',
  },
  maxSessionExceeded: {
    id: 'core.errorNotification.messages.maxSessionExceeded',
    defaultMessage: 'Maximum amount of sessions exceeded',
  },
  connectionLost: {
    id: 'core.errorNotification.messages.connectionLost',
    defaultMessage:
      'Connection with server is broken. Try do it after reconnect.',
  },
  passwordExpired: {
    id: 'core.errorNotification.messages.passwordExpired',
    defaultMessage: 'Password expired',
  },
  accountDisabled: {
    id: 'core.errorNotification.messages.accountDisabled',
    defaultMessage: 'Account is disabled',
  },
  accountLocked: {
    id: 'core.errorNotification.messages.accountLocked',
    defaultMessage: 'Account is locked',
  },
  accountExpired: {
    id: 'core.errorNotification.messages.accountExpired',
    defaultMessage: 'Account is expired',
  },
  logonTimeRestriction: {
    id: 'core.errorNotification.messages.logonTimeRestriction',
    defaultMessage: 'Logon is not permitted at this time',
  },
  workstationRestriction: {
    id: 'core.errorNotification.messages.workstationRestriction',
    defaultMessage: 'Logon is not permitted from this workstation',
  },
  actionCancelled: {
    id: 'core.errorNotification.messages.actionCancelled',
    defaultMessage: 'Action was cancelled.',
  },
  maxPinnedTabsExceeded: {
    id: 'core.errorNotification.messages.maxPinnedTabsExceeded',
    defaultMessage: 'You cannot pin more than 5 tabs.',
  },
} as const);
